import { useRequest } from 'umi';
import React, { useState } from 'react';
import { Rate, message } from 'antd';
import { LikeOutlined, LikeFilled } from '@ant-design/icons';
import { postPraise } from '@/utils/requests/camp/requests_dynamic';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';

interface props {
  data: DynamicType;
  type: number;
}
const DynamicPraise: React.FC<props> = (props) => {
  const item = props.data;
  const [praiseCount, setPraiseCount] = useState(item.praiseCount > 0 ? item.praiseCount : '');
  const [rateValue, setRateValue] = useState(item.praise ? 1 : 0);

  // 点赞接口
  const { run: postPraisePageRequest } = useRequest(
    () => {
      const params = {
        bePraiseId: item.id,
        bePraiseUid: item.createdBy,
        type: props.type,
      };
      return postPraise(params);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setPraiseCount(res.praiseCount > 0 ? res.praiseCount : '');
        if (res.praise) {
          message.success('点赞成功');
        } else {
          message.success('已取消点赞');
        }
      },
    },
  );
  const handleRateChange = (value: any) => {
    setRateValue(value);
    postPraisePageRequest();
  };

  return (
    <Rate
      key={item.id}
      defaultValue={rateValue}
      count={1}
      onChange={handleRateChange}
      character={() => {
        return rateValue === 1 ? (
          <div className="colffa f16 flex_1">
            <LikeFilled />
            <div className="f14">
              <span style={{ margin: '0 6px' }}>点赞</span>
              <span>{praiseCount}</span>
            </div>
          </div>
        ) : (
          <div className="col808 f16 flex_1">
            <LikeOutlined />
            <div className="f14">
              <span style={{ margin: '0 6px' }}>点赞</span>
              <span>{praiseCount}</span>
            </div>
          </div>
        );
      }}
    />
  );
};
export default DynamicPraise;
